var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 21" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M18.2 12.4c-1-1.8-.4-4.1 1.4-5.2l-2-3.4c-.6.3-1.2.5-1.9.5-2 .1-3.6-1.4-3.7-3.4V.4H8c0 .7-.1 1.4-.5 1.9-1 1.8-3.3 2.4-5.1 1.4l-2 3.4c.6.5 1 1 1.4 1.5 1 1.8.4 4.1-1.4 5.2l2 3.4c.6-.2 1.2-.4 1.9-.4 2 .1 3.6 1.8 3.7 3.8h3.9c0-.7.1-1.3.5-1.9 1.1-1.8 3.4-2.4 5.2-1.4l2-3.4c-.6-.3-1-.8-1.4-1.5zM10 14.7c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Settings.svg